<template>
  <div class="flex items-end">
    <lm-input
      ref="inputBudget"
      label="budget"
      class=""
      :maxlength="0"
      :optional="true"
      @submit="$emit('submit')"
    />
    <select v-model="currency" class="mb-8 h-6 ml-6 text-xs">
      <option value="">currency</option>
      <option v-for="opt in currencyOptions" :key="opt.value" :value="opt.value"
        >{{ opt.label }}
      </option>
    </select>
  </div>
</template>
<script>
import LmInput from '@/components/form/LmInput.vue'
export default {
  name: 'LmCurrencySelect',
  components: {
    LmInput
  },
  data() {
    return {
      currency: '€',
      currencyOptions: [
        {value: '€', label: '€ (EUR)'},
        {value: '$', label: '$ (USD)'},
        {value: '£', label: '£ (GBP)'},
        {value: '¥', label: '¥ (CNY)'}
      ]
    }
  },
  methods: {
    validateData() {
      return true
    },
    getData() {
      return (
        this.$refs.inputBudget.data + (this.currency ? ` ${this.currency}` : '')
      )
    },
    setData(budget) {
      if (!budget) return
      // check if budget contains currency
      const currencySymbol = budget[budget.length - 1]
      const currentCurrency = this.currencyOptions.find(
        opt => opt.value === currencySymbol
      )
      if (currentCurrency) {
        this.currency = currentCurrency.value
        this.$refs.inputBudget.data = budget.slice(0, -1).trim()
      } else {
        this.$refs.inputBudget.data = budget
      }
    }
  }
}
</script>
